import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import dataV from '@jiaminghi/data-view'
import SafeDvCharts from '@/components/SafeDvCharts/index.vue'
import '@/style/common.scss'
import '@/theme/screen-theme.scss'
import '@/map/district-map.scss'

Vue.use(dataV)
Vue.component('dv-charts', SafeDvCharts)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
